import { Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Shown when entering a program was refused by the ladder entry rule (the
 * student has not completed the program it builds on). The registrar may retry
 * with a reason; the server audits it. Used by every dialog that lets a student
 * enter a program.
 */
export function StackEntryOverrideField({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation('sis');
  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {t('admissionDetail.stackEntry.overrideHelp')}
      </Typography>
      <TextField
        size="small"
        fullWidth
        autoFocus
        label={t('admissionDetail.stackEntry.reasonLabel')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...(disabled !== undefined ? { disabled } : {})}
      />
    </Stack>
  );
}
